var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"defaultValue":_vm.selectedTimeZoneVal},on:{"change":function($event){return _vm.selectChange($event)}}},_vm._l((_vm.timeZones),function(item){return _c('a-select-option',{key:item.value,attrs:{"value":item.value}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }